import React from "react";
import { useTranslation } from "react-i18next";

import styles from "./ChangeSuitForm.module.css";

interface Props {
  handleSubmit: (suit: string) => void;
}

export default function ChangeSuitForm({ handleSubmit }: Props) {
  const [newSuit, setNewSuit] = React.useState<string | null>(null);
  const { t } = useTranslation();

  function onChangeHandler(event: React.ChangeEvent<HTMLInputElement>) {
    const { nativeEvent } = event;

    // Handle click event
    //
    // There is a bug that triggers onClick event when using the cursor keys
    // Read more at:
    // - https://github.com/facebook/react/issues/7407
    if (
      nativeEvent instanceof MouseEvent &&
      nativeEvent.clientX !== 0 &&
      nativeEvent.clientY !== 0
    ) {
      handleSubmit(event.target.value);
    } else {
      // handle keyboard event
      setNewSuit(event.target.value);
    }
  }

  function onKeyUpHandler(event: React.KeyboardEvent) {
    if (event.key === "Enter" || event.key === " ") {
      if (newSuit !== null) {
        handleSubmit(newSuit);
      }
    }
  }

  return (
    <form className={styles.form}>
      <div className={styles.wrapper}>
        <input
          type="radio"
          name="suit"
          value="blue"
          id="suit-blue"
          required
          className={styles.radio}
          onChange={onChangeHandler}
          onKeyUp={onKeyUpHandler}
        />
        <label className={`${styles.label} ${styles.blue}`} htmlFor="suit-blue">
          {t("ChangeSuitForm.blue")}
        </label>
      </div>
      <div className={styles.wrapper}>
        <input
          type="radio"
          name="suit"
          value="green"
          id="suit-green"
          required
          className={styles.radio}
          onChange={onChangeHandler}
          onKeyUp={onKeyUpHandler}
        />
        <label
          className={`${styles.label} ${styles.green}`}
          htmlFor="suit-green"
        >
          {t("ChangeSuitForm.green")}
        </label>
      </div>
      <div className={styles.wrapper}>
        <input
          type="radio"
          name="suit"
          value="orange"
          id="suit-orange"
          className={styles.radio}
          required
          onChange={onChangeHandler}
          onKeyUp={onKeyUpHandler}
        />
        <label
          className={`${styles.label} ${styles.orange}`}
          htmlFor="suit-orange"
        >
          {t("ChangeSuitForm.orange")}
        </label>
      </div>
      <div className={`${styles.wrapper} ${styles.red}`}>
        <input
          type="radio"
          name="suit"
          value="red"
          id="suit-red"
          className={styles.radio}
          required
          onChange={onChangeHandler}
          onKeyUp={onKeyUpHandler}
        />
        <label className={`${styles.label} ${styles.red}`} htmlFor="suit-red">
          {t("ChangeSuitForm.red")}
        </label>
      </div>
    </form>
  );
}
